import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { querySiteTree, getTenantStByToken, ajaxGetDictItems } from '@/api/api';
import eventBus from '@/utils/eventBus.js';
export default {
  name: 'siteSelect',
  data: function data() {
    return {
      category: '',
      categoryList: [],
      value: '1',
      st: '',
      stList: [],
      showSearchBox: false,
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      treeData: [],
      checkedKeys: [],
      expandedKeys: [],
      currentKey: '',
      siteId: ''
    };
  },
  props: {},
  created: function created() {
    var _this = this;

    this.getCategoryList();
    var that = this;
    window.addEventListener('setItem', function (e) {
      if (e.key == 'siteId') {
        _this.siteId = sessionStorage.getItem('siteId');
      }
    });
    this.getTenantStList();
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    getCategoryList: function getCategoryList() {
      var _this2 = this;

      ajaxGetDictItems('site_st52_category', null).then(function (res) {
        if (res.success) {
          _this2.categoryList = res.result;
        }
      });
    },
    getTenantStList: function getTenantStList() {
      var _this3 = this;

      getTenantStByToken().then(function (res) {
        if (res.success) {
          if (res.result && res.result.length > 0) {
            _this3.stList = res.result;

            _this3.stList.unshift({
              value: '',
              title: '请选择监测站点类型',
              text: '请选择监测站点类型'
            });

            if (res.result.length < 2) {
              _this3.typeChange(res.result[0].value);
            }
          }
        } else {
          _this3.stList.unshift({
            value: '',
            title: '请选择监测站点类型',
            text: '请选择监测站点类型'
          });
        }

        if (sessionStorage.getItem('selectTreeCategory')) {
          _this3.category = sessionStorage.getItem('selectTreeCategory');
          sessionStorage.setItem('selectTreeCategory', '');
        } else {
          if (_this3.stList.length <= 2) {
            _this3.category = '3';
          } else {
            _this3.category = '';
          }
        }

        _this3.loadTree(_this3.value, _this3.st, _this3.category);
      });
    },
    // 类型字典变化
    typeChange: function typeChange(val) {
      this.st = val;
      this.loadTree(this.value, val, this.category);
    },
    // 过滤节点
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 显示搜索条件
    showSearch: function showSearch() {
      this.showSearchBox = !this.showSearchBox;
    },
    handleChange: function handleChange(value) {},
    onChange: function onChange(e) {
      this.loadTree(e.target.value, this.st, this.category);
    },
    onCategoryChange: function onCategoryChange(e) {
      console.log("checked = ".concat(e.target.value));
      this.loadTree(this.value, this.st, e.target.value);
    },
    // 自定义图标
    renderContent: function renderContent(h, _ref) {
      var node = _ref.node,
          data = _ref.data,
          store = _ref.store;
      var icon;

      if (data.data && data.data.st) {
        switch (data.data.st) {
          case '31':
            icon = 'icon-feiqi';
            break;

          case '32':
            icon = 'icon-yiliaofeishui';
            break;

          case '35':
            icon = 'icon-turang';
            break;

          case '21':
            icon = 'icon-shuizhijiancezhan';
            break;

          case '22':
            icon = 'icon-kongqijiance';
            break;

          case '61':
            icon = 'icon-shuikushuiwenzhan';
            break;

          case '52':
            icon = 'icon-yiliaofeishui';
            break;
        }
      }

      var rex = /^[a-zA-Z]/; // if (data.total == 0 && rex.test(data.key[0])) {
      // } else {

      return h("span", {
        "class": "custom-tree-node"
      }, [h("span", {
        "directives": [{
          name: "show",
          value: data.isLeaf && !rex.test(data.key[0])
        }],
        "attrs": {
          "title": node.label + '\n' + (data.online ? '在线' : '离线') + (data.data.currentStandard ? '，' + data.data.currentStandard.title : '') + (data.data.upStandard === 'true' ? '，达标' : data.data.upStandard === null ? '' : '，不达标') + (data.data.lastTime ? '\n' + data.data.lastTime : '')
        },
        "style": "display:flex;align-items:center;"
      }, [h("div", {
        "directives": [{
          name: "show",
          value: data.online
        }],
        "style": "font-size:0.7rem;margin-right:3px;",
        "class": 'iconfont ' + icon
      }), h("div", {
        "directives": [{
          name: "show",
          value: !data.online
        }],
        "style": "font-size:0.7rem;margin-right:3px;color:gray;",
        "class": 'iconfont ' + icon
      }), node.label.length > this.testLength - 2 ? node.label.slice(0, this.testLength - 2) + '...' : node.label]), h("span", {
        "directives": [{
          name: "show",
          value: !data.isLeaf
        }]
      }, [node.label, "(", data.onlineNum, "/", data.total, ")"]), h("div", {
        "directives": [{
          name: "show",
          value: data.data.currentStandard && data.isLeaf
        }],
        "style": {
          'font-size': '0.6rem',
          height: '20px',
          'line-height': '20px',
          padding: '0px 5px',
          'border-radius': '5px',
          position: 'absolute',
          right: '0',
          top: '3px',
          color: '#000',
          'background-color': data.data.currentStandard ? data.data.currentStandard.color : 'gray'
        }
      }, [data.data.currentStandard ? data.data.currentStandard.title : '']), h("div", {
        "directives": [{
          name: "show",
          value: !data.data.currentStandard && data.isLeaf && data.data.upStandard === 'true'
        }],
        "style": "font-size:0.6rem;height:20px;line-height: 20px;padding:0px 5px;border-radius:5px;position:absolute;right:0;top:3px;background-color:green;color:#fff;"
      }, ["\u8FBE\u6807"]), h("div", {
        "directives": [{
          name: "show",
          value: !data.data.currentStandard && data.isLeaf && data.data.upStandard === 'false'
        }],
        "style": "font-size:0.6rem;height:20px;line-height: 20px;padding:0px 5px;border-radius:5px;position:absolute;right:0;top:3px;background-color:red;color:#fff;"
      }, ["\u4E0D\u8FBE\u6807"])]); // }
    },
    getLast: function getLast(list) {
      var _this4 = this;

      var ids = {};
      if (sessionStorage.getItem('selectId')) ids = JSON.parse(sessionStorage.getItem('selectId'));

      if (ids.id) {
        var areaKey;

        if (ids.companyId) {
          areaKey = 'C_' + ids.companyId;
          list.forEach(function (items, indexs) {
            _this4.expandedKeys.push(items.key);

            items.children.forEach(function (item1, index1) {
              _this4.expandedKeys.push(item1.key);
            });
          });
        } else {
          areaKey = 'A_' + ids.areaId;
          list.forEach(function (items, indexs) {
            _this4.expandedKeys.push(items.key);
          });
        }

        this.expandedKeys.push(areaKey);
        this.expandedKeys.push(ids.id);
        this.siteId = ids.id;
        this.$emit('selectSite', {
          siteId: ids.id,
          siteName: ids.title,
          siteType: ids.st,
          category: this.category
        });
        this.$nextTick(function () {
          _this4.$refs.tree.setCurrentKey(_this4.siteId);
        });
        sessionStorage.setItem('selectId', []);
      } else {
        if (list[0].children && list[0].children.length > 0) {
          this.getLast(list[0].children);
          this.expandedKeys.push(list[0].key);
        } else {
          var siteObj = list[0];
          this.siteId = siteObj.key;
          this.$emit('selectSite', {
            siteId: siteObj.key,
            siteName: siteObj.title,
            siteType: siteObj.data.st,
            category: this.category
          });
          this.$nextTick(function () {
            _this4.$refs.tree.setCurrentKey(_this4.siteId);
          });
        }
      }
    },
    loadTree: function loadTree(addrType, st, category) {
      var that = this;
      querySiteTree({
        addrType: addrType,
        st: st,
        category: category
      }).then(function (res) {
        if (res.success) {
          that.treeData = res.result;
          that.getLast(that.treeData);
        }
      });
    },
    onSelect: function onSelect(data) {
      var _this5 = this;

      if (data.isLeaf) {
        this.siteId = data.key;
        var rex = /^[a-zA-Z]/;

        if (!rex.test(data.key[0])) {
          this.$nextTick(function () {
            _this5.$emit('selectSite', {
              siteId: data.key,
              siteName: data.title,
              siteType: data.data.st,
              category: _this5.category
            });

            _this5.currentKey = _this5.siteId;
          });
        }
      }
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};